import { Button } from "@offstreetparking/design-system/forms";
import { CheckIcon } from "@offstreetparking/design-system/icons/CheckIcon";
import { Heading } from "@offstreetparking/design-system/typography";

type SummaryContentProps = {
	title: React.ReactNode;
	titleAs?: "h2" | "h3";
	children: React.ReactNode;
	action?: {
		label: string;
		ariaLabel?: string;
		onClick: () => void;
	};
};

export const SummaryContent = (props: SummaryContentProps) => {
	const { children, title, titleAs = "h3", action } = props;
	return (
		<div className="flex gap-4">
			<div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success">
				<CheckIcon className="text-on-success" size={16} />
			</div>
			<div className="min-w-0 grow">
				<div className="flex items-center justify-between">
					<Heading As={titleAs} kind="h4" className="font-bold">
						{title}
					</Heading>
					{action && (
						<Button
							className="-mr-4 -my-1"
							intent="action"
							size="sm"
							type="button"
							onClick={action.onClick}
							aria-label={action.ariaLabel ?? action.label}
						>
							{action.label}
						</Button>
					)}
				</div>
				<div className="mt-0.5 text-sm">{children}</div>
			</div>
		</div>
	);
};
